import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-property-add',
  imports: [CommonModule, RouterModule, MaterialModule, FormsModule, ReactiveFormsModule],
  templateUrl: './property-add.component.html',
  styleUrl: './property-add.component.scss'
})
export class PropertyAddComponent {
  propertyForm: FormGroup;
  panel: any

  options:any = ['House', 'Villa', 'Appartment']

  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    public dialogRef: MatDialogRef<PropertyAddComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    this.panel = dialogData?.panel;
    console.log('dialogDaa', dialogData)
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.propertyForm = this.fb.group({
      email: [''],
    })
  }
}
